import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
  styled,
  useTheme,
} from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 20,
    padding: theme.spacing(3),
    maxWidth: '90%',
    margin: theme.spacing(2),
    background: theme.palette.background.paper,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 400,
      padding: theme.spacing(4),
    },
  },
}));

const StatusHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

const StatusIconWrapper = styled(Box)(({ theme }) => ({
  width: 64,
  height: 64,
  borderRadius: '50%',
  backgroundColor: theme.palette.error.lighter || theme.palette.error.light,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
}));

const BannedUserBanner = ({ userData, logout }) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const handleFixThis = () => {
    window.open('https://www.youtube.com/watch?v=xvFZjo5PgG0&list=RDxvFZjo5PgG0&start_radio=1&ab_channel=Duran', '_blank');
  };

  const handleSignOut = async () => {
    try {
      setLoading(true);
      await logout();
    } catch (error) {
      console.error('Error signing out:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledDialog 
      open 
      fullWidth 
      maxWidth="sm"
      disableEscapeKeyDown={loading}
    >
      <DialogContent sx={{ p: 0, textAlign: 'center' }}>
        <StatusHeader>
          <StatusIconWrapper>
            <BlockIcon sx={{ fontSize: 32, color: 'error.main' }} />
          </StatusIconWrapper>
          <Typography variant="h6" align="center" sx={{ fontWeight: 600, mb: 1 }}>
            Sorry, you can't access this
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            Think this is a mistake? Please reach out to support.
          </Typography>
        </StatusHeader>

        <ButtonContainer>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleFixThis}
            disabled={loading}
            sx={{
              borderRadius: 2,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: theme.shadows[2],
              },
            }}
          >
            Don't Press This
          </Button>
          
          <Button
            fullWidth
            variant="outlined"
            color="inherit"
            onClick={handleSignOut}
            disabled={loading}
            sx={{
              borderRadius: 2,
              py: 1.5,
              textTransform: 'none',
              color: 'text.secondary',
              borderColor: 'grey.300',
              '&:hover': {
                borderColor: 'grey.400',
              },
            }}
          >
            Sign Out
          </Button>
        </ButtonContainer>
      </DialogContent>
    </StyledDialog>
  );
};

export default BannedUserBanner;